theme.$doc.on('click', '.quantity__button.quantity__button--inc', function () {
    let $this = $(this);
    let $input = $this.closest('.quantity').find('input');
    let $val = parseInt($input.val(), 10);
    $input.val($val + 1);
    $input.trigger('change');
});

theme.$doc.on('click', '.quantity__button.quantity__button--dec', function () {
    let $this = $(this);
    let $input = $this.closest('.quantity').find('input');
    let $val = parseInt($input.val(), 10);
    $input.val(Math.max(1, $val - 1));
    $input.trigger('change');
});
